import { COMMON_HEADERS } from "./restApi";

import type { QueryParams, RequestHeaders } from "./restApi";

/**
 * Per-request headers merged by axios into the request config.
 * Returns undefined when there is nothing to merge (axios keeps default/common headers only).
 */
export function buildAxiosConfigWithHeaders(headers?: RequestHeaders): { headers: RequestHeaders } | undefined {
    if (headers === undefined || Object.keys(headers).length === 0) {
        return undefined;
    }

    return { headers: { ...headers } };
}

/**
 * Axios config for GET/DELETE (query params + optional per-request headers).
 */
export function buildAxiosQueryConfigWithHeaders(
    params?: QueryParams,
    headers?: RequestHeaders
): { params?: QueryParams; headers?: RequestHeaders } | undefined {
    const headersConfig = buildAxiosConfigWithHeaders(headers);
    if (params === undefined && headersConfig === undefined) {
        return undefined;
    }

    const config: { params?: QueryParams; headers?: RequestHeaders } = {};
    if (params !== undefined) {
        config.params = params;
    }

    if (headersConfig !== undefined) {
        config.headers = headersConfig.headers;
    }

    return config;
}

/**
 * Headers for fetch() JSON POST (common + optional + JSON + Authorization).
 * Authorization is omitted while the client is unauthenticated, otherwise fetch
 * would send a placeholder value the server has to reject.
 */
export function buildHeadersForFetchConfig(
    authorization: string | undefined,
    headers?: RequestHeaders
): RequestHeaders {
    const merged: RequestHeaders = Object.assign({}, COMMON_HEADERS, headers || {}, {
        "Content-Type": "application/json",
    });
    if (authorization === undefined) {
        delete merged.Authorization;
    } else {
        merged.Authorization = authorization;
    }
    return merged;
}
